import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../../types';

const defaultData: IDataLayer = {
  offerFailed: {
    event_name: 'offer_code',
    event_category: 'viewcart',
    event_action: 'cart_offer_fail',
    event_label: null, // <offerCode> - <offerCode>
  },

  offerSuccessful: {
    event_name: 'offer_code',
    event_category: 'viewcart',
    event_action: 'cart_offer_success',
    event_label: null, // <offer code> - <offerCode>
  },

  offerRemove: {
    event_name: 'offer_code',
    event_category: 'viewcart',
    event_action: 'cart_offer_remove',
    event_label: null, // <offer code> - <offerCode>
  },
};

function trackOffer(eventName: string, eventData: IDataLayer = {}) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eventData.offer_code?.forEach((code: any) => {
    eventData.event_label = `${code}`;
    tealium.evtLink({ ...defaultData[eventName], ...eventData });
  });
}

Object.keys(defaultData).forEach((key) => {
  registerAnalyticsEventHandler(key, trackOffer);
});
